module.exports = __webpack_public_path__ + "static/img/settings_aboutus.dc9a4b18.svg";